import { combineReducers } from '@reduxjs/toolkit';

import ssf from 'selective_solder_fixtures/store/slice';

const rootReducer = combineReducers({
  ssf,
});

export default rootReducer;
